export const MIN_LOADING_TIME_MS = 300;
export const AUTH_TOKEN_STORAGE_KEY = 'fss_token';
export const AUTH_REFRESH_TOKEN_STORAGE_KEY = 'fss_refreshToken';
export const NOTIFICATIONS_PAGE_SIZE = 10;
